module.exports = __webpack_public_path__ + "7cc85add6131dc49b54054dc9e78f07c.svg";